import React from 'react';
import { useSelector } from 'react-redux';

import BlogItem from './../../Main/Components/Blog/BlogItem';

const BlogPage = () => {
    const blog = useSelector(state => state.blog.blog);
    return (
        <main className='blog_page'>
            <div className="blog_page--block _container">
                <div className="project_content--text">
                    <div className="project--front_title">Recent Blogs</div>
                    <div className="project--subb">Get updates about our latest trends and techniques used in interior design project works.</div>
                </div>
                <div className="blog__item--container">
                    {blog.map(el => (
                        <BlogItem key={el.id} item={el} />
                    ))}
                </div>
            </div>
        </main>
    )
}

export default BlogPage;